module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("8tbRj"))).then(() => parcelRequire('3ifTP'));